export const TAB_ITEMS = [
  {
    key: 'general-settings',
    label: 'General Settings',
    value: 'general-settings',
    href: '/account/general-settings'
  },
  {
    key: 'safer-gambling',
    label: 'Safer Gambling',
    value: 'safer-gambling',
    href: '/account/safer-gambling'
  },
  {
    key: 'verification',
    label: 'Account Verification',
    value: 'verification',
    href: '/account/verification'
  },
  {
    key: 'integrations',
    label: 'Integrations',
    value: 'integrations',
    href: '/account/integrations'
  },
];

export const DEFAULT_TAB = 'settings';
